exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.three-line-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 16px; /* fallback */\n  max-height: calc(16px * 3); /* fallback */\n}\n", ""]);

// exports
